//include 8
jQuery(function(){
    var breadcrumbs = $("ul.breadcrumbs");
    var breadcrumbsSessionKey = "breadcrumbs.";

    var setPositions = function(){
        if(breadcrumbs.length > 0){
            var breadcrumbsParts = breadcrumbs.find(" > li.bread");
            breadcrumbsParts.each(function( index ){
                var meta = $(this).find('meta[itemprop="position"]');
                if(meta.length > 0){
                    meta.attr("content",index+1);
                }
            });
        }
    }

    if (breadcrumbs.length == 0 || !window.pixelpoint.utilities.hasLocalStorage()) {
        setPositions();
        return;
    }

    var privateFunctions = {
        getReferrer(){
            var referrer = document.referrer;
            if(!referrer)
                return null;
            referrer = this.parseUrl(referrer);
            if(!!referrer && referrer.pathname == window.location.pathname)
                return null;
            return referrer;
        },
        parseUrl: function (url) {
            if (!url) {
                return null;
            }
            var parser = document.createElement('a');
            parser.href = url;
            return {
                'href': parser.href,
                'protocol': parser.protocol,
                'hostname': parser.hostname,
                'port': parser.port,
                'pathname': parser.pathname,
                'search': parser.search,
                'hash': parser.hash,
                'host': parser.host
            };
        },
        getBreadcrumbsData: function () {
            var breadcrumbsDataContainer = $("body").find(".breadcrumbs-data");//breadcrumbs.find(".breadcrumbs-data");
            if (breadcrumbsDataContainer.length == 0)
                return {};
            var type = breadcrumbsDataContainer.data("pageType") || "static";
            var pageId = breadcrumbsDataContainer.data("pageId") || 0;
            var title = breadcrumbsDataContainer.data("pageTitle") || "";
            var original = breadcrumbsDataContainer.find("ul").html() || "";

            original = original.replace(/data-structured-/g,'');

            //breadcrumbsDataContainer.remove();

            return {
                'type': type,
                'id': pageId,
                'title': title,
                'original': original
            };
        },
        saveBreadcrumbs(breadcrumbs, current) {
            var breadcrumbsHtml = breadcrumbs;
            if (typeof breadcrumbs != "string") {
                var breadcrumbsClone = breadcrumbs.clone();
                breadcrumbsClone.find(".breadcrumbs-data").remove();
                breadcrumbsHtml = breadcrumbsClone.html();
                breadcrumbsHtml = breadcrumbsHtml.replace(/data-structured-/g,'');
            }
            var key = breadcrumbsSessionKey + current.pathname;
            window.sessionStorage.setItem(key, breadcrumbsHtml);
        },
        loadBreadcrumbs(referrer) {
            if(!referrer || !referrer.pathname)
                return null;
            var key = breadcrumbsSessionKey + referrer.pathname;
            return window.sessionStorage.getItem(key);
        },
        getCurrentBreadcrumbPart(breadcrumbs, current) {
            var breadcrumbsObject = breadcrumbs;
            if (typeof breadcrumbsObject == "string") {
                breadcrumbsObject = $(breadcrumbsObject);
            } else if (breadcrumbsObject instanceof jQuery) {
                breadcrumbsObject = breadcrumbsObject.clone();
            }
            breadcrumbsObject = $('<div>').append(breadcrumbsObject);
            var lastNode = breadcrumbsObject.find('li.bread').last();
            if (!!current && !!current.href && lastNode.find("a").length == 0) {
                var text = lastNode.text();
                lastNode.wrapInner(`<a href="${current.href}" target="_self" title="${text}"></a>`);
            }
            return $('<div>').append(lastNode).html();
        },
        addLinkToLastElement(breadcrumbsHtml, current) {
            var breadcrumbsObject = breadcrumbsHtml;
            if (typeof breadcrumbsObject == "string") {
                breadcrumbsObject = $(breadcrumbsObject);
            } else if (breadcrumbsObject instanceof jQuery) {
                breadcrumbsObject = breadcrumbsObject.clone();
            }
            breadcrumbsObject = $('<div>').append(breadcrumbsObject);
            var lastNode = breadcrumbsObject.find("li").last('li.bread');
            if (!!current && !!current.href && lastNode.find("a").length == 0) {
                var text = lastNode.text();
                lastNode.wrapInner(`<a href="${current.href}" target="_self" title="${text}"></a>`);
            }
            //return $('<div>').append(breadcrumbsObject).html();
            return breadcrumbsObject.html();
        }
    }

    //********************************************** */
    var referrer = privateFunctions.getReferrer();
    var current = document.location;
    var breadcrumbsData = privateFunctions.getBreadcrumbsData();

    if (!!breadcrumbsData.type) {
        switch (breadcrumbsData.type) {
            case 'static':
                privateFunctions.saveBreadcrumbs(breadcrumbs, current);
                break;
            case 'detail':
            case 'dynamic':
                var breadcrumbsFromReferrer = privateFunctions.loadBreadcrumbs(referrer);
                if(!!referrer)
                    breadcrumbsFromReferrer = privateFunctions.addLinkToLastElement(breadcrumbsFromReferrer,referrer);
                if (!!breadcrumbsFromReferrer) {
                    var breadcrumbPart = privateFunctions.getCurrentBreadcrumbPart(breadcrumbs);
                    var newBreadcrumbs = breadcrumbsFromReferrer + breadcrumbPart;

                    var breadcrumbPartWithLink = privateFunctions.getCurrentBreadcrumbPart(breadcrumbs, current);
                    var newBreadcrumbsWithLink = breadcrumbsFromReferrer + breadcrumbPartWithLink;
                    privateFunctions.saveBreadcrumbs(newBreadcrumbsWithLink, current);
                    breadcrumbs.html(newBreadcrumbs).addClass("dynamic");
                } else {
                    var newBreadcrumbs = breadcrumbsData.original;
                    var newBreadcrumbsWithLink = privateFunctions.addLinkToLastElement(newBreadcrumbs, current);
                    privateFunctions.saveBreadcrumbs(newBreadcrumbsWithLink, current);
                    breadcrumbs.html(newBreadcrumbs).addClass("dynamic");
                }
                break;
        }
    }
    
    setPositions();
    //********************************************** */
});